import checkout from "./form";

const {
  formField: {
    taxpayers,
    taxCode,
    taxAgentName,
    taxAgentCode,

    from,
    firstTime,
    mst,
    strangeFrom,
    strangeTo,
    time,
    capitalTransfer,
    transferofsharePurchaseRights,
    differentAgreedMethod,
    agreedMethod,
    transferOfCapitalContributionRights,

    chiefAccountant,
    certificateNumber,
    unitHeads,
    dateFounded,
  },
} = checkout;

const initialValues = {
  [taxpayers.name]: "",
  [taxCode.name]: "",
  [taxAgentName.name]: "",
  [taxAgentCode.name]: "",

  [from.name]: "",
  [firstTime.name]: false,
  [mst.name]: "",
  [strangeFrom.name]: "",
  [strangeTo.name]: "",
  [time.name]: "",
  [capitalTransfer.name]: false,
  [transferofsharePurchaseRights.name]: false,
  [differentAgreedMethod.name]: false,
  [agreedMethod.name]: false,
  [transferOfCapitalContributionRights.name]: false,

  [chiefAccountant.name]: "",
  [certificateNumber.name]: "",
  [unitHeads.name]: "",
  [dateFounded.name]: "",
};

export default initialValues;
